// PromoFinancingConfiguration.js - Main entry point for Promo/Financing Configuration
// This component renders the tabbed interface for managing promotions and financing offers
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

// Import tab components
import PromotionsTab from './PromotionsTab';
import FinancingTab from './FinancingTab';

const PromoFinancingConfiguration = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: 'Promotions', component: <PromotionsTab /> },
    { label: 'Financing', component: <FinancingTab /> },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2 }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {tabs[activeTab]?.component}
    </Box>
  );
};

export default PromoFinancingConfiguration;
